export const checkedCopmany=(a)=>{
        return {
            type:"CHECKED",
            value:a
        }
}